export const DATA_COPY_SUBMIT_REQUEST = 'DATA_COPY_SUBMIT_REQUEST';
export const DATA_COPY_SUBMIT_SUCCESS = 'DATA_COPY_SUBMIT_SUCCESS';
export const DATA_COPY_SUBMIT_FAILURE = 'DATA_COPY_SUBMIT_FAILURE';
export const DATA_COPY_SUBMIT_DUPLICATE = 'DATA_COPY_SUBMIT_DUPLICATE';

export const CLICK_EMAIL_US_REQUEST = 'CLICK_EMAIL_US_REQUEST';
export const CLICK_EMAIL_US_SUCCESS = 'CLICK_EMAIL_US_SUCCESS';
export const CLICK_EMAIL_US_FAILURE = 'CLICK_EMAIL_US_FAILURE';

export const CHECK_CHAT_AVAILABILITY_REQUEST = 'CHECK_CHAT_AVAILABILITY_REQUEST';
export const CHECK_CHAT_AVAILABILITY_SUCCESS = 'CHECK_CHAT_AVAILABILITY_SUCCESS';
export const CHECK_CHAT_AVAILABILITY_FAILURE = 'CHECK_CHAT_AVAILABILITY_FAILURE';

export const CHAT_START = 'CHAT_START';

export const SET_INITIAL_DATA = 'SET_INITIAL_DATA';
export const SET_INITIAL_COUNTRY = 'SET_INITIAL_COUNTRY';

export const UPDATE_ISSUE_SELECTION = 'UPDATE_ISSUE_SELECTION';
export const SET_DEFAULT_CONTACT_NOTE = 'SET_DEFAULT_CONTACT_NOTE';
export const SET_UPLOADED_FILES = 'SET_UPLOADED_FILES';
export const SET_ENERGY_SCHEDULING_TEAM = 'SET_ENERGY_SCHEDULING_TEAM';

export const REQUEST_SENT = 'requestSent';
export const REQUEST_FAILED = 'requestFailed';
export const REQUEST_IN_PROGRESS = 'requestInProgress';
export const REQUEST_SENDING = 'requestSending';

export const RECALLS = 'recalls';

export const EMMC_REIMBURSEMENT = 'emmcReimbursement';

export const SUBMIT_REIMBURSEMENT_REQUEST = 'SUBMIT_REIMBURSEMENT_REQUEST';
export const SUBMIT_REIMBURSEMENT_SUCCESS = 'SUBMIT_REIMBURSEMENT_SUCCESS';
export const SUBMIT_REIMBURSEMENT_FAILURE = 'SUBMIT_REIMBURSEMENT_FAILURE';
export const RESET_REQUEST_STATUS = 'RESET_REQUEST_STATUS';

export const UPLOAD_FILE_STATUS = 'UPLOAD_FILE_STATUS';

export const DEMOGRAPHIC_FORM_INPUT_CHANGE = 'DEMOGRAPHIC_FORM_INPUT_CHANGE';
export const PAYOR_FORM_INPUT_CHANGE = 'PAYOR_FORM_INPUT_CHANGE';
export const RESET_PAYOR_FORM = 'RESET_PAYOR_FORM';

export const SHOW_GLOBAL_LOADER = 'SHOW_GLOBAL_LOADER';
export const HIDE_GLOBAL_LOADER = 'HIDE_GLOBAL_LOADER';

export const FETCH_TROUBLESHOOTING_CONFIG = 'FETCH_TROUBLESHOOTING_CONFIG';
export const SET_TROUBLESHOOTING_GUIDE = 'SET_TROUBLESHOOTING_GUIDE';
export const SET_COMPLETED_TROUBLESHOOTING_GUIDE = 'SET_COMPLETED_TROUBLESHOOTING_GUIDE';
export const SET_TROUBLESHOOTING_SUPPORT_OVERRIDES = 'SET_TROUBLESHOOTING_SUPPORT_OVERRIDES';

export const CHECK_ACCOUNT_REQUEST = 'CHECK_ACCOUNT_REQUEST';
export const CHECK_ACCOUNT_SUCCESS = 'CHECK_ACCOUNT_SUCCESS';
export const CHECK_ACCOUNT_FAILURE = 'CHECK_ACCOUNT_FAILURE';
